import { gql } from "@apollo/client"

export const GET_VEHICLE_QUERY = gql`
    query Vehicle($id: MongoID!) {
        vehicle(_id: $id) {
            identifier
            licencePlate
            engineNumber
            capacity
            odometer
            form {
                _id
            }
            shifts {
                _id
                jobs {
                    jobId
                    grouping {
                        type
                        groupId
                    }
                }
            }
        }
    }
`
